module.exports = __webpack_public_path__ + "img/check-transaction.a7bc3275.png";